import { render, staticRenderFns } from "./EditingTranslationTable.vue?vue&type=template&id=a89f2880&"
import script from "./EditingTranslationTable.vue?vue&type=script&lang=js&"
export * from "./EditingTranslationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports